/* EstablishedMales — theme interactions */
(function () {
  'use strict';

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile nav ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('.mobile-nav');
  var navClose = document.querySelector('[data-nav-close]');
  function closeNav() { if (mobileNav) { mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; } }
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () { mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; });
  }
  if (navClose) navClose.addEventListener('click', closeNav);
  if (mobileNav) mobileNav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeNav); });

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 0.08 + 's'; io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Accordions (product details) ---------- */
  document.querySelectorAll('.accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion__item');
      var content = item.querySelector('.accordion__content');
      var isOpen = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen);
      content.style.maxHeight = isOpen ? content.scrollHeight + 'px' : 0;
    });
  });

  /* ---------- Product option selectors ---------- */
  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    group.querySelectorAll('.option__value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.option__value').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var input = group.querySelector('input[type="hidden"]');
        if (input) input.value = btn.dataset.value;
      });
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('.qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (b.dataset.step === 'down') v = Math.max(1, v - 1); else v = v + 1;
        input.value = v;
      });
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  var gMain = document.querySelector('[data-gallery-main]');
  if (gMain) {
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        gMain.src = t.dataset.full || t.src;
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (x) { x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  /* ---------- Newsletter (static-preview only fallback) ---------- */
  document.querySelectorAll('[data-demo-newsletter]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = form.parentElement.querySelector('.newsletter__success');
      if (msg) { msg.textContent = 'Welcome to the Establishment. Check your inbox.'; }
      form.reset();
    });
  });
})();
